import { Container, Text } from "@mantine/core";

import { BINGO_GAME_NOT_CONNECTED } from "_constants";

import { useBingoGame } from "bingo/hooks/useBingoGame";

import { PlayBingoGameLoader } from "bingo/play/components/PlayBingoGameLoader";

import PlayBingoGameView from "./PlayBingoGameView";
import { withDebug } from "common/debug/components/withDebug";
import { DEFAULT_WHITE_COLOR } from "../../../_graphic_design";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useSavedEvent } from "event/hooks/useSavedEvent";
import type { Event } from "event/types/event.model";
import { useSavedBingoGame } from "bingo/hooks/useSavedBingoGame";
//import { useGetPlayerQuery } from "quiz/api/players.endpoints";

function PlayBingoGamePresenterComponent() {
  const bingoGame = useBingoGame();
  const location = useLocation();
  const _state = location.state as { event?: Event } | undefined;
  const event = _state?.event;
  const savedEvent = useSavedEvent(event?.id || "")[0];
  const { bingoGameId } = useParams();
  const [savedGame] = useSavedBingoGame(bingoGameId!);
  const navigate = useNavigate();

  void navigate;

  //const [gameState, setGameState] = useState<GameState | undefined>();
  let playerId: string;
  let partitionId: string;

  if (savedEvent) {
    ({ playerId, partitionId } = savedEvent);
  } else {
    ({ playerId, partitionId } = savedGame || {});
  }
  console.log(playerId);
  console.log(partitionId);
  console.log("playerInfo", savedEvent?.playerInfo);

  const payload = savedEvent?.playerInfo;
  // const { data: playerEventData } = useGetPlayerQuery([playerId, partitionId]);

  if (bingoGame && playerId && partitionId) {
    return (
      <PlayBingoGameView
        bingoGame={bingoGame}
        playerId={playerId}
        partitionId={partitionId}
        playerInfo={payload}
      />
    );
  }
  // if (bingoGame && !playerId && !partitionId) {
  //   navigate("../../../");
  // }

  if (!bingoGame) {
    return (
      <Container pb={"lg"}>
        <PlayBingoGameLoader
          message={
            <Text
              className="text-2xl text-center font-bold"
              sx={{
                color: DEFAULT_WHITE_COLOR,
              }}
              dangerouslySetInnerHTML={{ __html: BINGO_GAME_NOT_CONNECTED }}
            />
          }
        />
      </Container>
    );
  }

  // if (!bingoGame) {
  //   return <PlayBingoGameView bingoGame={data} />;
  // }

  // Handle the case where data is null but not loading
  return (
    <Container pb={"lg"}>
      <PlayBingoGameLoader
        message={
          <Text
            className="text-2xl text-center bold"
            sx={{
              color: DEFAULT_WHITE_COLOR,
            }}
            dangerouslySetInnerHTML={{ __html: BINGO_GAME_NOT_CONNECTED }}
          />
        }
      />
    </Container>
  );
}

export const PlayBingoGamePresenter = withDebug(
  PlayBingoGamePresenterComponent,
);
